

export enum PropertyDetailTabNames {
  Overview  = 'Overview',
  LocationMap = 'Location Map',
  Activities = 'Activities',
  Log = 'Log',
}
  
  